<div *ngIf="formGroup"
     [formGroup]="formGroup">

  <div class="row no-gutters">
    <div class="col-12 col-lg mb-contact-form-margin-right field-wrapper text-sm-left mb-input-margin-bottom"
         mbFloatingLabel data-cy="mb-first-name">
      <label for="firstName" [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'mandatory-input-asterisk mb-custom-label mb-input-field-cursor']">{{ firstNameLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="firstName"
             name="firstName"
             formControlName="firstName"
             data-cy="mb-first-name-input"
             type="text"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.FIRST_NAME_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>

    <div class="col-12 col-lg field-wrapper text-sm-left mb-input-margin-bottom"
         mbFloatingLabel data-cy="mb-last-name">
      <label for="lastName" [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'mandatory-input-asterisk mb-custom-label mb-input-field-cursor']">{{ lastNameLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="lastName"
             name="lastName"
             formControlName="lastName"
             data-cy="mb-last-name-input"
             type="text"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.LAST_NAME_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>

  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper"
         mbFloatingLabel
         data-cy="mb-email">
      <label [ngClass]="[isEmailDisabled || isFormDisabled ? 'mb-disable-label' : '', 'mandatory-input-asterisk mb-custom-label mb-input-field-cursor']"
             for="email">{{ emailLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             type="email"
             id="email"
             name="email"
             formControlName="email"
             data-cy="mb-email-input"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.EMAIL_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>

  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper"
         mbFloatingLabel data-cy="mb-phone">
      <label for="phoneNumber" [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'mb-custom-label mb-input-field-cursor']">{{ phoneNumberLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             type="text"
             id="phoneNumber"
             name="phoneNumber"
             formControlName="phoneNumber"
             data-cy="mb-phone-input"/>
    </div>
  </div>

</div>

